import {
  Button,
  ButtonGroup,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
} from "@material-ui/core";
import { remove } from "lodash";
import React from "react";
import Component from "src/shared/components/Component";
import withAxios from "src/shared/components/withAxios";
import { ISeason, ISeasonSportRequest } from "src/api/types";
import { getAdminApi } from "../../seasonsPage/utils/getAdminApi/getAdminApi";
import { IProps, ISeasonsPageState } from "./types";

export default withAxios(
  class extends Component<IProps, ISeasonsPageState> {
    public render() {
      const { seasons, selectedSeason, sport } = this.props;

      return (
        <ListItem divider={true}>
          <ListItemText primary={`${sport.name}`} />
          <ListItemSecondaryAction>
            <ButtonGroup>
              {seasons.map((season) => {
                const isSeason = (seasonToCheck: ISeason | undefined) =>
                  seasonToCheck !== undefined && seasonToCheck.id === season.id;

                const isSelectedSeason = isSeason(selectedSeason);
                return (
                  <Button
                    key={season.id}
                    color="secondary"
                    variant={isSelectedSeason ? "contained" : "outlined"}
                    onClick={() => this.updateSeasonSport(season)}
                  >
                    {season.name}
                  </Button>
                );
              })}
            </ButtonGroup>
          </ListItemSecondaryAction>
        </ListItem>
      );
    }

    private updateSeasonSport = async (season: ISeason) => {
      this.runCancellableStatefulAsync(
        this,
        {
          submittingSeason: season,
          submittingSeasonSport: true,
        },
        {
          submittingSeason: undefined,
          submittingSeasonSport: undefined,
        },
        async () => {
          const {
            sport,
            schoolId,
            seasons,
            defaultSeasons,
            seasonsChange,
            loadSeasons,
            selectedSeason,
          } = this.props;
          const seasonSport = {
            schoolId,
            seasonId: season.id,
            sportId: sport.id,
          };
          await this.buildPut<ISeasonSportRequest, void>(
            this,
            `${getAdminApi(defaultSeasons)}seasonSport`
          )(seasonSport);
          // preset the seasonsData to what I think the loaded data will bring back
          // this makes the interface seem more snappy
          seasonsChange(
            seasons.map((sC) => {
              // add sport to season if is not
              if (selectedSeason !== undefined && sC.id === selectedSeason.id) {
                // empty
              } else {
                if (sC.id === season.id) {
                  return {
                    ...sC,
                    sportIds: [...sC.sportIds, sport.id],
                  };
                }
              }

              // remove from season if found
              return {
                ...sC,
                sportIds: remove(
                  [...sC.sportIds],
                  (sportId) => sportId !== sport.id
                ),
              };
            })
          );
          // actually load the data back
          loadSeasons();
        },
        () => {
          window.alert("Failed to update season sport");
          this.setState({
            submittingSeason: undefined,
            submittingSeasonSport: undefined,
          });
        }
      );
    };
  }
);



// WEBPACK FOOTER //
// ./src/features/director/pages/seasons/components/season-sport-list-item/SeasonSportListItem.tsx